import React from 'react';
import { SelectedDataReceivedStatusType } from './utils';
import StatusSelect, { StatusSelectValueProps } from './StatusSelect';

// TODO: сделать общими с подсказками в иконках
export const DATA_RECEIVED_STATUS = Object.freeze({
  ALL: 'Все программы наблюдения поступили в срок',
  PART: 'Часть программ наблюдения не поступили в срок',
  NONE: 'Программы наблюдения не поступили в срок',
  unknown: 'Статус отправки: Неизвестно',
});

// @ts-ignore
export function DataReceivedStatusSelect(props: StatusSelectValueProps<SelectedDataReceivedStatusType>) {
  return (
  // @ts-ignore
    <StatusSelect
      {...props}
      statusDescription={DATA_RECEIVED_STATUS}
      allValuesLabel="Все статусы отправки"
    />
  );
}
export default DataReceivedStatusSelect;
